var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mt-3",attrs:{"title":"Plans"}},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields}},[_c('template',{slot:"action"},[_c('b-button',{attrs:{"size":"sm"}},[_vm._v("Edit")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }